import { createRoot } from "react-dom/client";
import "./index.css";
import Root from "./AppWrapper";
import * as serviceWorker from "./serviceWorker";
import "react-toastify/dist/ReactToastify.css";
import 'react-datepicker/dist/react-datepicker.css';

const container = document.getElementById("root");
const root = createRoot(container);
root.render(<Root />);

serviceWorker.unregister();
